export interface ThemePalette {
  id: string;
  name: string;
  primary: string;
  hover: string;
  light: string;
}

export const DEFAULT_THEME_ID = 'ocean';

export const THEME_PALETTES: ThemePalette[] = [
  { id: 'ocean', name: 'Ocean', primary: '#0f8BBD', hover: '#0d7aab', light: '#E6F4FA' },
  { id: 'teal', name: 'Teal', primary: '#0F8B8D', hover: '#0D7A7C', light: '#E6F7F6' },
  { id: 'indigo', name: 'Indigo', primary: '#4F46E5', hover: '#4338CA', light: '#EEF2FF' },
  { id: 'emerald', name: 'Emerald', primary: '#059669', hover: '#047857', light: '#ECFDF5' },
  { id: 'violet', name: 'Violet', primary: '#7C3AED', hover: '#6D28D9', light: '#F3E8FF' },
  { id: 'rose', name: 'Rose', primary: '#E11D48', hover: '#BE123C', light: '#FFF1F2' },
];
